import { render } from "./ShortDescription.vue?vue&type=template&id=2201eba8"
import script from "./ShortDescription.vue?vue&type=script&lang=js"
export * from "./ShortDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__